import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { SlideShowModel } from "../../models/slideshow.model";
import { NotificationService } from "../../services/notification.service";
import { PictureModel } from "../../models/picture.model";
import { PaginationService } from '../../services/pagination.service';
import { QueryConfig } from '../../models/queryConfig.model';
declare var require: any
@Component({
    selector: 'slide-show',
    templateUrl: './slideshow.component.html',
    styleUrls: ['../../app.component.css']
})

export class SlideShowComponent implements OnInit {
    @Input() model: SlideShowModel;
    @Input() scrollable: boolean = false;
    @Input() queryConfig: QueryConfig = null;

    public titleImageUrl: string = "../../../assets/images/animations/flowers3.gif";

    public titleImageGif = require("../../../assets/images/animations/flowers3.gif");

    public onShownPic: PictureModel;

    public total: number = 0;

    public currentIndex: number = 0;

    public pictureHeight: number;

    constructor(public page: PaginationService<PictureModel>,
        private notificationService: NotificationService
    ) { }

    ngOnInit(): void {
        if (this.model == null) {
            throw new Error('slide show model is null');
        }
        if (this.scrollable) {
            if (!this.queryConfig) {
                throw new Error('config is null');
            }
            this.page.init<PictureModel>(this.queryConfig.path,
                this.queryConfig.field,
                this.queryConfig.queryField,
                this.queryConfig.queryValue,
                this.queryConfig.opts);
        }
        // for (let i = 0; i < this.model.pictures.length; i++) {
        //     let type = this.model.pictures[i].type;
        //     let tags = type.split(";");
        //     for(let j = 0; j < tags.length ; j++){
        //         if (this.model.types.indexOf(tags[j]) < 0) {
        //             this.model.types.push(tags[j]);
        //         }
        //     }
        // }
        this.total = this.model.pictures.length;
        this.pictureHeight = window.innerHeight;
    }

    scrollHandler(e) {
        if (e === 'bottom') {
            this.page.more<PictureModel>()
        }
    }
    showPicture(event, picture: PictureModel, index: number) {
        event.preventDefault();
        this.notificationService.notifyBody(true);
        this.onShownPic = picture;
        this.currentIndex = index;
    }

    hideSlideShow() {
        this.onShownPic = null;
        this.notificationService.notifyBody(false);
    }

    next() {
        this.currentIndex += 1;
        if (this.currentIndex > this.total - 1) {
            this.currentIndex = 0;
        }
        this.onShownPic = this.model.pictures[this.currentIndex];
    }

    previous() {
        this.currentIndex -= 1;
        if (this.currentIndex < 0) {
            this.currentIndex = this.total - 1;
        }
        this.onShownPic = this.model.pictures[this.currentIndex];
    }

    @HostListener('window:resize', ['$event'])
    private onResize(event) {
        this.pictureHeight = event.target.innerHeight;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/slideshow/slideshow.component.ts